import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="lot-activity-heatmap"
//
// Manages tooltip rendering for heatmap cells and dispatches a
// `lot-activity:show-all` CustomEvent on click so the matching activity
// card scrolls into view and expands its rows filtered to that date.
export default class extends Controller {
  connect() {
    this.tooltipEl = null
  }

  disconnect() {
    if (this.tooltipEl) {
      this.tooltipEl.remove()
      this.tooltipEl = null
    }
  }

  showTooltip(event) {
    const cell = event.currentTarget
    const html = cell.dataset.tooltipHtml
    if (!html) return

    if (!this.tooltipEl) {
      this.tooltipEl = document.createElement("div")
      this.tooltipEl.setAttribute("role", "tooltip")
      this.tooltipEl.className =
        "fixed z-50 px-2 py-1 text-xs rounded shadow-lg bg-base-content text-base-100 pointer-events-none whitespace-nowrap"
      document.body.appendChild(this.tooltipEl)
    }

    this.tooltipEl.innerHTML = html
    const rect = cell.getBoundingClientRect()
    this.tooltipEl.style.left = `${rect.left + rect.width / 2}px`
    this.tooltipEl.style.top = `${rect.top - 6}px`
    this.tooltipEl.style.transform = "translate(-50%, -100%)"
    this.tooltipEl.style.opacity = "1"
  }

  hideTooltip() {
    if (this.tooltipEl) {
      this.tooltipEl.style.opacity = "0"
    }
  }

  dayClicked(event) {
    const cell = event.currentTarget
    const cardKey = cell.dataset.cardKey
    const date = cell.dataset.date
    if (!cardKey || !date) return

    window.dispatchEvent(
      new CustomEvent("lot-activity:show-all", { detail: { cardKey, date } })
    )
  }
}
